export const lightTheme = {
    bodyPrimary: 'white',
    textPrimary: 'DarkSlateGray',

    bodySecondary: '#5bc0de',
    textSecondary: 'white',

    cardBackground: 'lightgrey',
    cardborder: 'DarkSlateGray',

    cardBackground2: '#d5d8dc',
    cardborder2: 'DarkSlateGray',

    inputdBackground: 'white',
    inputText: 'DarkSlateGray',

    toggleBorder: '#FFF',
    gradient: 'linear-gradient(#39598A, #79D7ED)',
    bgImgGradient1 : 'rgba(4, 203, 253, 0.589) 0%', 
    bgImgGradient2 : 'rgba(252, 252, 252, 0.5) 34%', 
    bgImgGradient3 : 'rgba(143, 143, 143, 0.5) 100%'
    
  }
  
  export const darkTheme = {
    bodyPrimary: '#4d4d4d',
    textPrimary: '#d9d9d9',

    bodySecondary: '#279bbe',
    textSecondary: 'DarkSlateGray',

    cardBackground: '#808080',
    cardborder: '#d9d9d9',

    cardBackground2: '#808080',
    cardborder2: 'DarkSlateGray',

    inputdBackground: 'lightgrey',
    inputText: 'black',

    toggleBorder: '#6B8096',
    gradient: 'linear-gradient(#091236, #1E215D)',
    bgImgGradient1 : 'rgba(0, 0, 0, 0.555) 0', 
    bgImgGradient2 : 'rgba(0, 0, 0, 0.555) 34%', 
    bgImgGradient3 : 'rgba(0, 75, 119, 0.5) 100%',
  }